export const getBooleanFormYesOrNoText = (option?: string | boolean) => {
  if (!option) return false
  if (typeof option === 'boolean') return option
  return option === 'yes'
}
